<template>
    <div class="hotadmain">
        <div class="itemrow">
            <div class="itemrow_one" v-for="(item,index) in list" :key="index">
                <img :src="item.photo1">
            </div>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["list"],
  mounted() {
  }
};
</script>

<style lang="less">
.itemrow {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between; 
  width: 100%;
  .itemrow_one {
    width: 375px;
    img {
      width: 100%;
      height: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/hotad.vue